import React from "react"
import { Divider, Input, Select, Space } from "antd"
import { capitalize } from "lodash"
import { useTranslation } from "react-i18next"
import { EcommerceShippingRule } from "@/types/ecommerce"
import { IDispatchRule } from "@/types/dispatchRules.types"
import RuleFormModalButton from "@/modules/profile/DispatchSettings/RuleFormModalButton/RuleFormModalButton.container"
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface DeliveryMethodSelectRuleProps {
  key: number
  disabled?: boolean
  isBeingEdited: boolean
  currentRule?: IDispatchRule
  shippingRule: EcommerceShippingRule
  rulesOptions: { value: string; label: string }[]
  handleSelectRule: (shippingRuleId: string, dispatchRuleId: string) => void
}

const DeliveryMethodSelectRule: React.FC<DeliveryMethodSelectRuleProps> = ({
  key,
  disabled,
  isBeingEdited,
  currentRule,
  shippingRule,
  rulesOptions,
  handleSelectRule,
}) => {
  const { t } = useTranslation()

  return (
    <div id="shipping-rule-select-container" className="row-span-1" key={key}>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-6 md:col-span-4">
          <Input
            id="shipping-rule-name"
            className="rounded-md !text-black select-none"
            value={capitalize(shippingRule.name)}
            style={{ cursor: "pointer !important", height: 40 }}
            size="large"
            disabled
          />
        </div>
        <div className="col-span-6 md:col-span-5">
          <Select
            id="dispatch-rule-select"
            className={`!h-full w-full ${isBeingEdited ? "select-editing" : ""}`}
            size="large"
            placeholder={t("common.selectRule")}
            options={rulesOptions}
            defaultValue={currentRule?.name}
            disabled={disabled}
            onClick={(e) => e.stopPropagation()}
            allowClear={true}
            onClear={() => handleSelectRule(shippingRule.id, "")}
            onSelect={(dispatchRuleId: string) => handleSelectRule(shippingRule.id, dispatchRuleId)}
            dropdownStyle={{ zIndex: 0 }}
            dropdownRender={(menu) => {
              return (
                <>
                  {menu}
                  <Divider style={{ margin: "8px 0" }} />
                  <Space style={{ padding: "0 8px 4px" }}>
                    <RuleFormModalButton
                      button={
                        <div className="flex cursor-pointer">
                          <FontAwesomeIcon
                            className="flex flex-shrink-0 h-3 mx-auto my-auto text-kosmoBlue ml-1 mr-2"
                            icon={faCirclePlus}
                          />
                          <p> {t("profile.EmptySettingBox.createNewRule")}</p>
                        </div>
                      }
                    />
                  </Space>
                </>
              )
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default DeliveryMethodSelectRule
